import { post, upload, AHPLUS_API_URL } from 'api/ky';
import {
  type InsuranceType,
  type AirBundleDocumentParam,
} from 'types/airBundleDocuments';

const PRESIGNED_URL = `${AHPLUS_API_URL}/api/v2/s3/presigned_url`;

export const getPresignedUrl = async (
  fileType: string,
  insuranceType: InsuranceType,
  documentType: AirBundleDocumentParam,
  resourceId: number,
  insuranceId: number,
) => {
  return post(PRESIGNED_URL, {
    fileType,
    insuranceType,
    resourceId,
    documentType,
    insuranceId,
  });
};

export const uploadDocument = async (
  file: File,
  insuranceType: InsuranceType,
  documentType: AirBundleDocumentParam,
  resourceId: number,
  insuranceId: number,
) => {
  const [error, apiResponse] = await getPresignedUrl(
    file.type,
    insuranceType,
    documentType,
    resourceId,
    insuranceId,
  );
  if (apiResponse) {
    const s3response = await upload(apiResponse.presignedUrl, file);
    if (s3response.status === 200) {
      return apiResponse.fileName;
    }
    throw s3response;
  }
  throw error;
};

export default { uploadDocument };
